<template>
  <div class="tw:w-full">
    <p class="tw:font-bold tw:text-xl tw:text-gray-800 tw:my-2">{{ $t('app_hotel_details_address') }}</p>
    <div class="tw:flex tw:flex-col tw:gap-2">
      <BaseTextField
        :label="$t('app_hotel_details_address')"
        name="streetAddress"
        aria-label="streetAddress"
        type="text"
        required
        class="tw:w-full tw:mb-4 tw:md:mb-auto"
        size="medium"
        :error="errors['streetAddress'] ? $t(errors['streetAddress']) : false"
        :value="address"
        @onChange="e => setValue('streetAddress', e)"
      />
      <BaseTextField
        :label="$t('app_hotel_details_zip_code')"
        name="postalCode"
        aria-label="postalCode"
        type="text"
        required
        class="tw:w-full tw:mb-4 tw:md:mb-auto"
        size="medium"
        :error="errors['postalCode'] ? $t(errors['postalCode']) : false"
        :value="zip"
        @onChange="e => setValue('postalCode', e)"
      />
      <CityAutocompleteField
        :locale="language"
        :label="$t('app_hotel_details_city')"
        name="city"
        aria-label="city"
        type="text"
        class="tw:w-full tw:mb-4 tw:md:mb-auto"
        size="medium"
        :options="[]"
        :value="city"
        @onSelect="e => setCityInfo(e)"
      />
      <BaseTextField
        :label="
          currentAccommodation && currentAccommodation.countryId === 83
            ? $t('tBS_CIN_header')
            : $t('tBS_alternative_accommodation_ID')
        "
        :hint="
          currentAccommodation && currentAccommodation.countryId === 83
            ? $t('tBS_CIN_license_info_text')
            : $t('tBS_alternative_accommodation_ID_info_text')
        "
        :placeholder="
          currentAccommodation && currentAccommodation.countryId === 83
            ? $t('tBS_CIN_prompt_text')
            : $t('tBS_alternative_accommodation_ID_prompt_text')
        "
        name="propertyId"
        aria-label="propertyId"
        type="string"
        class="tw:w-full tw:mb-4 tw:md:mb-auto"
        size="medium"
        :error="errors['propertyId'] ? $t(errors['propertyId']) : false"
        :value="propertyId"
        @onChange="e => setValue('propertyId', e)"
      />
    </div>
  </div>
</template>
<script setup>
import { onMounted } from 'vue'

import { usePropertyDetailsBasicInfo } from '@/components/propertyDetails/propertyBasicInfo/usePropertyDetailsBasicInfo.js'
import { validate, required } from '@/utils/propertyDetailsHelpers.ts'
import { useAccommodationsByOrgId } from '@/layouts/queries'
import { useSessionValues } from '@/composables/useSessionValues'

import BaseTextField from '@/components/base/inputs/BaseTextField.vue'
import CityAutocompleteField from '@/components/propertyDetails/propertyBasicInfo/edit/CityAutocompleteField.vue'

const { language, selectedOrganisationId } = useSessionValues()
const { setNewPropertyValues, setValidation, setNewValue } = usePropertyDetailsBasicInfo()
const { currentAccommodation } = useAccommodationsByOrgId(selectedOrganisationId)
const props = defineProps({
  errors: Object,
  address: String,
  zip: String,
  city: String,
  propertyId: String,
})

const getValidations = name => {
  if (name === 'streetAddress' || name === 'postalCode') {
    return [required]
  } else {
    return []
  }
}

onMounted(() => {
  const fieldsToValidate = [
    { name: 'streetAddress', value: props.address },
    { name: 'postalCode', value: props.zip },
  ]
  fieldsToValidate.forEach(item => {
    const validationFunctions = getValidations(item.name)
    const error = validate(item.value, validationFunctions)
    setValidation({
      name: item.name,
      value: error !== undefined ? error : false,
    })
  })
})

const setValue = (name, value) => {
  const validationFunctions = getValidations(name)
  const error = validate(value, validationFunctions)
  setValidation({ name, value: error !== undefined ? error : false, isFormValid: error === undefined })
  setNewPropertyValues({ name, value })
}
const setCityInfo = item => {
  setNewPropertyValues({ name: 'city', value: item.name })
  setNewValue({ name: 'city', value: item.name })
}
</script>
